import { render } from "./JobSeekersView.vue?vue&type=template&id=4109c493&scoped=true"
import script from "./JobSeekersView.vue?vue&type=script&lang=js"
export * from "./JobSeekersView.vue?vue&type=script&lang=js"

import "./JobSeekersView.vue?vue&type=style&index=0&id=4109c493&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4109c493"]])

export default __exports__